<template>
  <div class="grid-default">
    <div class="col-span-6 mb-4 text-base text-blue-950 lg:mb-0">
      <div class="mb-2 font-semibold lg:mb-3">
        {{ data.headline }}
      </div>
      <div v-html="data.descriptionText" />
    </div>
    <div class="col-span-6">
      <Image
        v-if="data.tipImage"
        loading="lazy"
        class="aspect-video rounded-3xl object-cover"
        :src="
          data.tipImage.responsiveImage ? data.tipImage.responsiveImage?.src : data.tipImage.url
        "
        :srcset="
          data.tipImage.responsiveImage ? data.tipImage.responsiveImage?.webpSrcSet : undefined
        "
        :width="data.tipImage.width"
        :height="
          data.tipImage.responsiveImage
            ? data.tipImage.responsiveImage?.height
            : data.tipImage.height
        "
        :alt="data.tipImage.alt"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TipRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<TipRecord>,
    default: () => {}
  }
})
</script>
